import React from "react"
import "./modal.scss"
import { IoClose } from "react-icons/io5"

type ModalProps = {
  onClose?: () => void
  title?: string
  children: React.ReactNode
  dismissable?: boolean
  containerStyles?: React.CSSProperties
  hideCloseButton?: boolean
  bodyStyles?: React.CSSProperties
}

export const Modal = ({
  onClose,
  title,
  children,
  dismissable = true,
  containerStyles = {},
  hideCloseButton = false,
  bodyStyles = {}
}: ModalProps) => {
  return (
    <div
      className="modal-overlay"
      onClick={ev => {
        if (dismissable && ev.target === ev.currentTarget) {
          // enable closing by clicking outside the modal
          onClose?.()
        }
      }}
    >
      <div className="modal-container" style={containerStyles}>
        {dismissable ? <div className="close-button">
          <IoClose onClick={onClose}/>
        </div> : null}
        {title ? <h2 className="text-center fs-3">{title}</h2> : null}
        <div className="modal-body" style={bodyStyles}>{children}</div>
        {dismissable && !hideCloseButton ? <div className="text-center">
          <button onClick={onClose} className="btn btn-secondary">
            Close
          </button>
        </div> : null}
      </div>
    </div>
  )
}
